// extracted by mini-css-extract-plugin
module.exports = {"container":"CardsSkeleton_container__PxJxD","product_skeleton_card_container":"CardsSkeleton_product_skeleton_card_container__phX8B","show-map":"CardsSkeleton_show-map__we2Hb"};